// Shared utility for formatting user info into AssociatesData shape
import { AssociatesData } from "../context/ProfileContext";
import { AssociatesData as JobInvitationData } from "../hooks/scheduler/useWerkerSelection";

/**
 * Format user data for associate request management (Associates page)
 * Returns data with AssociateStatus and isRead_Request fields
 */
export function userInfoFormatting(userData: any, details: any): AssociatesData {
  return {
    WerkerUid: userData?.WerkerUid || userData?.uid || details?.Uid || "",
    WerkerFirstName: userData?.WerkerFirstName || userData?.firstName || "",
    WerkerLastName: userData?.WerkerLastName || userData?.lastName || "",
    WerkerCompany: userData?.WerkerCompany || userData?.company || "",
    WerkerProfilePicURL: userData?.WerkerProfilePicURL || userData?.profilePicURL || "../assets/profilePic.png",
    WerkerBio: userData?.WerkerBio || userData?.bio || "",
    Occupation: userData?.Occupation || userData?.occupation || "",
    AssociateStatus: details?.AssociateStatus || "",
    isRead_Request: details?.isRead_Request ?? true,
  };
}

/**
 * Format user data for job invitation/werker selection
 * Returns data with isInvited and DocId fields
 */
export function formatForJobInvitation(userData: any, invited: boolean, docId: string): JobInvitationData {
  return {
    WerkerUid: userData.WerkerUid,
    WerkerFirstName: userData.WerkerFirstName || "",
    WerkerLastName: userData.WerkerLastName || "",
    WerkerCompany: userData.WerkerCompany || "",
    WerkerProfilePicURL: userData.WerkerProfilePicURL || "",
    isInvited: invited,
    WerkerBio: userData.WerkerBio || "",
    DocId: docId,
  };
}
